import { Command, HttpMethod } from "~/extensions/api";
export class AgreeTermsOfUseCommand extends Command {
    constructor() {
        super(HttpMethod.Post, "termsOfUse/agree");
    }
}
